module.exports = __webpack_public_path__ + "static/media/coillte.3edea56a.png";